import {
    GET_BRANDING_CONFIG_REQUEST,
    GET_BRANDING_CONFIG_SUCCESS,
    GET_BRANDING_CONFIG_ERROR,
    UPDATE_BRANDING_CONFIG_REQUEST,
    UPDATE_BRANDING_CONFIG_SUCCESS,
    UPDATE_BRANDING_CONFIG_ERROR,
    UPLOAD_BRANDING_LOGO_REQUEST,
    UPLOAD_BRANDING_LOGO_SUCCESS,
    UPLOAD_BRANDING_LOGO_ERROR
} from './types';

const initialState = {
    brandingConfig: null,
    loading: false,
    error: null
};

const brandingReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_BRANDING_CONFIG_REQUEST:
        case UPDATE_BRANDING_CONFIG_REQUEST:
        case UPLOAD_BRANDING_LOGO_REQUEST:
            return { ...state, loading: true, error: null };

        case GET_BRANDING_CONFIG_SUCCESS:
            return { ...state, loading: false, brandingConfig: payload };

        case UPDATE_BRANDING_CONFIG_SUCCESS:
            return { ...state, loading: false, brandingConfig: payload };

        case UPLOAD_BRANDING_LOGO_SUCCESS:
            return { ...state, loading: false };

        case GET_BRANDING_CONFIG_ERROR:
        case UPDATE_BRANDING_CONFIG_ERROR:
        case UPLOAD_BRANDING_LOGO_ERROR:
            return { ...state, loading: false, error: true };

        default:
            return state;
    }
};

export default brandingReducer;
